import axios from 'axios'
import React from 'react'
import { IFileApartment, IRequestApartments } from '../../interfaces'
import { errorHandler, PageService } from '../../services'
import { Button } from '../../components'
import { toast } from 'react-toastify'
import { SpinnerLoader } from '../../assets/icons'

export default function Home(): React.ReactElement {
    const [isLoading, setIsLoading] = React.useState(false)
    const [groupedApartments, setGroupedApartments] = React.useState<{ [key: string]: IRequestApartments[] }>({})

    async function init(): Promise<void> {
        try {
            setIsLoading(true)
            const requestApartments: IRequestApartments[] = await PageService.getRequestApartments()
            const grouped: { [key: string]: IRequestApartments[] } = {}

            requestApartments.forEach((apartment) => {
                const key = apartment.realEstate.name
                if (grouped[key]) {
                    grouped[key].push(apartment)
                } else {
                    grouped[key] = [apartment]
                }
            })

            setGroupedApartments(grouped)
        } catch (error) {
            toast(errorHandler(error).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    React.useEffect(() => {
        init()
    }, [])

    return (
        <div className="card min-height">
            <div className="home">
                <div className="box_text">
                    <h4>Arquivos para download</h4>
                    <p className="description">Escolha o arquivo que deseja baixar e clique no botão download.</p>
                </div>
                <div className="box_apartment">
                    {Object.entries(groupedApartments).map(([key, groupApartments]) => (
                        <React.Fragment key={key}>
                            {groupApartments.map((apartment) => {
                                return (
                                    <div id="card" key={apartment.id}>
                                        <h5>
                                            {apartment.realEstate.name} | Apto {apartment.number}
                                        </h5>
                                        <div className="box_download">
                                            {apartment.realEstateApartmentFiles.map((file) => {
                                                return (
                                                    <div className="box_pdf" key={file.id}>
                                                        <p>{file.name}</p>
                                                        <ApartmentFile key={file.id} file={file} />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                )
                            })}
                        </React.Fragment>
                    ))}
                    {isLoading ? (
                        <div className="loader-page">
                            <SpinnerLoader />
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </div>
    )
}

function ApartmentFile(file: IFileApartment): React.ReactElement {
    async function fileDownload(id: number, fileName: string): Promise<void> {
        try {
            setIsLoading(true)
            const apartmentUrl = await PageService.getFileUrl(id)
            const response = await axios({
                method: 'GET',
                url: apartmentUrl.fileKey,
                responseType: 'blob',
            })
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName)
            link.setAttribute('target', '_blank')
            document.body.appendChild(link)
            link.click()
            link.remove()
            toast('Download realizado com sucesso!', { type: 'success' })
        } catch (error) {
            toast(errorHandler(error).message, { type: 'error' })
        } finally {
            setIsLoading(false)
        }
    }

    const [isLoading, setIsLoading] = React.useState(false)

    return (
        <Button
            isLoading={isLoading}
            type="button"
            placeholder="Download"
            disabled={isLoading}
            onClick={() => fileDownload(file.file.id, file.file.name)}
        />
    )
}
